import { observer } from "mobx-react";
import { Link } from "react-router-dom";

import Icon from "components/UI/IconSVG/Icon";
import Badges from "components/UI/Badges/Badges";

import "./ActionLink.scss";

const ActionLink = observer(({ action, path, isAnimated, isMobile, target }) => {
  return (
    <Link className={`main__action-link ${isAnimated ? "animated" : ""}`} to={path} target={target} onClick={() => window.scrollTo(0, 0)}>
      <div className="main__action-link-info">
        <Icon className="main__action-link-icon" sprite="activities" name={action.icon} />
        <div className="main__action-link-title">
          <p className="main__action-link-label">{action.title}</p>
          {!isMobile && <p className="main__action-link-sublabel">{action.titleComment}</p>}
        </div>
      </div>
      {isMobile && <div className="main__action-link-container">{action.titleComment}</div>}
      {action.statusForHomePage && <Badges status={action.statusForHomePage} />}
    </Link>
  );
});

export default ActionLink;
